export const UI_FEATURE_LOCK_TEMPLATE = Object.freeze({
  advancedReports: null,
  financialExecutive: null,
  billingAdvanced: null,
  aiTools: null,
  multiClinic: null,
  audit: null,
  executiveDashboard: null
})

export const BACKEND_FEATURE_TO_UI_FEATURE_KEY = Object.freeze({
  ADVANCED_REPORTS: "advancedReports",
  FINANCIAL_EXECUTIVE: "financialExecutive",
  BILLING_ADVANCED: "billingAdvanced",
  AI: "aiTools",
  AI_TOOLS: "aiTools",
  MULTI_CLINIC: "multiClinic",
  MULTI_CLINIC_VIEW: "multiClinic",
  AUDIT: "audit",
  EXECUTIVE_DASHBOARD: "executiveDashboard"
})

export function normalizeFeatureErrorPayload(rawError) {
  if (!rawError || typeof rawError !== "object") return null

  const payload =
    rawError?.code === "FEATURE_NOT_AVAILABLE"
      ? rawError
      : rawError?.response?.code === "FEATURE_NOT_AVAILABLE"
        ? rawError.response
        : null

  if (!payload) return null

  return {
    code: "FEATURE_NOT_AVAILABLE",
    message:
      payload?.message ||
      "Tu plan actual no incluye esta funcionalidad.",
    missingFeatures: Array.isArray(payload?.missingFeatures)
      ? payload.missingFeatures
      : [],
    recommendedPlans: Array.isArray(payload?.recommendedPlans)
      ? payload.recommendedPlans
      : [],
    currentPlan: payload?.currentPlan || null,
    clinicId: payload?.clinicId || null
  }
}